import { render, staticRenderFns } from "./HierarchyMenu.vue?vue&type=template&id=3f24be91&scoped=true&"
import script from "./HierarchyMenu.vue?vue&type=script&lang=js&"
export * from "./HierarchyMenu.vue?vue&type=script&lang=js&"
import style0 from "./HierarchyMenu.vue?vue&type=style&index=0&id=3f24be91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f24be91",
  null
  
)

export default component.exports